export const REPORT_TOGGLE_CLAIM_IMAGE_MODAL =
  'REPORT_TOGGLE_CLAIM_IMAGE_MODAL';
export const REPORT_SET_CLAIM_IMAGE_ID = 'REPORT_SET_CLAIM_IMAGE_ID';
export const REPORT_SET_REASON = 'REPORT_SET_REASON';
export const REPORT_SET_SUB_REASON = 'REPORT_SET_SUB_REASON';
